import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup, FlexBox } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { FormSectionTitle } from '../formSectionTitle';
import { MobileSetup } from './components/mobileSetup/mobileSetup';
import { ListPlatforms } from './components/pushNotifications/listPlatforms';
import { WebSetup } from './components/webSetup/webSetup';
export function Setup({ messengerId, messengerToken, }) {
    const [visibleTab, setVisibleTab] = useState('web');
    // eslint-disable-next-line consistent-return
    function renderTab() {
        switch (visibleTab) {
            case 'web':
                return _jsx(WebSetup, { messengerToken: messengerToken });
            case 'mobile':
                return _jsx(MobileSetup, { messengerToken: messengerToken });
            case 'pushNotifications':
                return _jsx(ListPlatforms, { messengerId: messengerId });
        }
    }
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(FormSectionTitle, { title: "Setup", description: "Instructions and documentation for how to set up your Dixa Messenger on your website and implement it on your application." }), _jsxs(ButtonGroup, Object.assign({ variant: "secondary" }, { children: [_jsx(Button, Object.assign({ icon: "chat-widget", active: visibleTab === 'web', onClick: () => setVisibleTab('web') }, { children: "Web" })), _jsx(Button, Object.assign({ icon: "phone", active: visibleTab === 'mobile', onClick: () => setVisibleTab('mobile') }, { children: "Mobile" })), _jsx(Button, Object.assign({ icon: "bell", active: visibleTab === 'pushNotifications', onClick: () => setVisibleTab('pushNotifications') }, { children: "Push notifications" }))] })), renderTab()] })));
}
